export default __webpack_public_path__ + "81e2773f8c3e0d5ae055d1c61f89a8a8.otf";